export default __webpack_public_path__ + "static/media/blueLogo.6b9d184a.png";